"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Accessibility = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M5,8 L18,8 C18.5522847,8 19,8.44771525 19,9 L19,9.21922359 C19,9.67809124 18.6877026,10.0780743 18.2425356,10.1893661 L15,11 L15,20 C15,20.5522847 14.5522847,21 14,21 L13.8198039,21 C13.3431229,21 12.9327081,20.6635403 12.8392232,20.1961161 L12,16 L11,16 L10.1607768,20.1961161 C10.0672919,20.6635403 9.65687712,21 9.1801961,21 L9,21 C8.44771525,21 8,20.5522847 8,20 L8,11 L4.75746437,10.1893661 C4.31229737,10.0780743 4,9.67809124 4,9.21922359 L4,9 C4,8.44771525 4.44771525,8 5,8 Z M5,9 L5,9.21922359 L9,10.2192236 L9,20 L9.1801961,20 L10.0194193,15.8038839 C10.1129042,15.3364597 10.523319,15 11,15 L12,15 C12.476681,15 12.8870958,15.3364597 12.9805807,15.8038839 L13.8198039,20 L14,20 L14,10.2192236 L18,9.21922359 L18,9 L5,9 Z M11.5,8 C10.1192881,8 9,6.88071187 9,5.5 C9,4.11928813 10.1192881,3 11.5,3 C12.8807119,3 14,4.11928813 14,5.5 C14,6.88071187 12.8807119,8 11.5,8 Z M11.5,7 C12.3284271,7 13,6.32842712 13,5.5 C13,4.67157288 12.3284271,4 11.5,4 C10.6715729,4 10,4.67157288 10,5.5 C10,6.32842712 10.6715729,7 11.5,7 Z" })));
};
Accessibility.displayName = 'Accessibility';
exports.default = Accessibility;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Accessibility.js.map